import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';

const ROOT_ID = 'libertify-playground-root';

function mount() {
  const el = document.getElementById(ROOT_ID);
  if (!el) {
    // The shortcode is not on this page — silently no-op.
    return;
  }

  // Ensure config exists. In WP this is set via wp_add_inline_script.
  if (!window.libertifyPlaygroundConfig) {
    window.libertifyPlaygroundConfig = {
      env: (el.dataset.env as 'production' | 'staging' | 'development') || 'production',
    };
  }

  ReactDOM.createRoot(el).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount, { once: true });
} else {
  mount();
}
